import NavBar from "@/components/landing/NavBar";
import Hero from "@/components/landing/Hero";
import TrustMatrix from "@/components/landing/TrustMatrix";
import Services from "@/components/landing/Services";
import Transformations from "@/components/landing/Transformations";
import BeforeAfter from "@/components/landing/BeforeAfter";
import RecentProjects from "@/components/landing/RecentProjects";
import Testimonials from "@/components/landing/Testimonials";
import ContactFooter from "@/components/landing/ContactFooter";

const LandingPage = () => {
  return (
    <main data-testid="landing-page" className="bg-white text-slate-900">
      <NavBar />
      <Hero />
      <TrustMatrix />
      <Services />
      <Transformations />
      <BeforeAfter />
      <RecentProjects />
      <Testimonials />
      <ContactFooter />
    </main>
  );
};

export default LandingPage;
